/**
 * Candles by Midnight — live fragrance description under the variant picker.
 *
 * snippets/pdp-fragrance-notes.liquid renders all twelve description panels
 * and hides the ones that are not selected. This swaps which one is visible
 * the moment the shopper picks a different fragrance.
 *
 * Why not rely on the section re-render: Sense re-fetches the product section
 * on variant change, but the fragrance block sits outside the swapped region,
 * so it kept the copy from page load. That is the bug this fixes — the pill
 * highlighted "Monsoon" while the text still described "Mysore".
 *
 * Reads the selected value defensively rather than assuming Sense's internals:
 * a checked radio, or a <select>, belonging to the Fragrance option. If it
 * cannot determine a value it leaves the current panel alone rather than
 * hiding everything.
 */
(function () {
  'use strict';

  var OPTION_NAME = 'fragrance';

  function normalise(s) {
    return (s || '').trim().toLowerCase();
  }

  /** Selected fragrance value within this product form, or null. */
  function selectedValue(root) {
    var scope = root.closest('.product, product-info, section') || document;

    // Radio-style pickers. Sense names inputs after the option.
    var radios = scope.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var name = normalise(r.name);
      var fieldset = r.closest('fieldset');
      var legend = fieldset ? normalise(fieldset.querySelector('legend') && fieldset.querySelector('legend').textContent) : '';
      if (name.indexOf(OPTION_NAME) !== -1 || legend.indexOf(OPTION_NAME) !== -1) {
        return r.value;
      }
    }

    // Dropdown-style pickers.
    var selects = scope.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      var sel = selects[j];
      var sname = normalise(sel.name);
      var label = sel.closest('.product-form__input');
      var labelText = label ? normalise(label.textContent) : '';
      if (sname.indexOf(OPTION_NAME) !== -1 || labelText.indexOf(OPTION_NAME) === 0) {
        return sel.value;
      }
    }
    return null;
  }

  function sync(root) {
    var value = selectedValue(root);
    if (!value) return;
    var panels = root.querySelectorAll('[data-frag-panel]');
    var matched = false;
    for (var i = 0; i < panels.length; i++) {
      var isMatch = normalise(panels[i].getAttribute('data-frag-panel')) === normalise(value);
      if (isMatch) matched = true;
      panels[i].hidden = !isMatch;
    }
    // Never leave the block empty: if the value matched nothing (a fragrance
    // added in Shopify but not yet added to the Liquid list), restore the
    // first panel rather than showing a blank gap.
    if (!matched && panels.length) panels[0].hidden = false;

    // Keep the "Compare all 12" list highlight in step.
    var rows = root.querySelectorAll('.pdp-frag__row');
    for (var k = 0; k < rows.length; k++) {
      var nameEl = rows[k].querySelector('.pdp-frag__name');
      var rowName = nameEl ? nameEl.textContent : '';
      rows[k].classList.toggle('is-selected', normalise(rowName) === normalise(value));
    }
  }

  function syncAll() {
    var roots = document.querySelectorAll('[data-frag-root]');
    for (var i = 0; i < roots.length; i++) sync(roots[i]);
  }

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches('input[type="radio"], select')) return;
    syncAll();
  });

  // Sense swaps the picker markup on variant change; re-read afterwards.
  document.addEventListener('variant:change', syncAll);
  document.addEventListener('DOMContentLoaded', syncAll);
  if (document.readyState !== 'loading') syncAll();
})();
